import { request } from "../../apis";

export const apiGetBlog = (params) => request("get", `/index/blogs`, params, true);

export const apiGetBlogDetail = (params) => request("get", `/index/blog`, params, true);
